import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setToken,
  setUser,
  showLoader,
  hideLoader,
} from "../../actions";
import { analytics } from "../../analytics";
import { LoaderComponent } from "../../components/loader";
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';


class SignUpNewComplete extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { provider, location, history } = this.props;
    if (provider || (location && location.state && location.state.provider === "signup")) {
      if (provider === "GOOGLE") {
        history.push("/");
      } else if (provider === "LINKEDIN") {
        history.push("/");
      } else if (provider === "APPLE") {
        history.push("/");
      } else {
        if (location && location.state && location.state.provider === "signup") {
          localStorage.setItem("firebaseSignupEvent", "registration_complete_email");
          localStorage.setItem("askOnboardingQues", true);
          history.push("/?sucessToken=" +
            localStorage.getItem('token') +
            "&provider=SIGNUP"); 
        } 
      }
    } else {
      history.push("/");
    }

  }

  render() {
    return (
      <React.Fragment>
        <Helmet title="Complete" >
          <script>{`
          gtag('event', 'conversion', {'send_to': 'AW-604883404/O2lJCJPQuI0CEMyTt6AC'});`
          }
          </script>
        </Helmet>
        <div className="background">
          <div className="container">
            <div className="row">
              <div className="col-12 no-gutter-col">
                <LoaderComponent isLoading={true} />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider,
    signUpFrom: state.signup.signUpForm,
    profile: state.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(SignUpNewComplete)
};
